module.exports = __webpack_public_path__ + "static/img/new_about5.641c531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_about5.png
// module id = 2IcR
// module chunks = 1